import { CommunicationLanguage, ContactLanguages } from "@/briefpoint-client";

export type ClientContactLanguageParams = {
  contactLanguage: ContactLanguages;
  previousCommunicationLanguage: CommunicationLanguage;
};

export type BulkSimplifyActionSource =
  | "emptySimplified"
  | "emptyVerbatim"
  | "remaining";

export function contactLanguageToCommunicationLanguage(
  contactLanguage: ContactLanguages | undefined,
): CommunicationLanguage {
  if (contactLanguage === ContactLanguages.Spanish) {
    return CommunicationLanguage.ES;
  }
  return CommunicationLanguage.EN;
}

// persisted task id: GET by communication may 404; we need the id after reload to poll GET /simplify-all/{taskId}

function simplifyAllTaskIdSessionKey(
  documentId: string,
  externalCommunicationId: string,
) {
  return `dbr:simplifyAllTaskId:${documentId}:${externalCommunicationId}`;
}

export function readSimplifyAllTaskIdFromSession(
  documentId: string,
  externalCommunicationId: string,
): string | null {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  return sessionStorage.getItem(
    simplifyAllTaskIdSessionKey(documentId, externalCommunicationId),
  );
}

export function writeSimplifyAllTaskIdToSession(
  documentId: string,
  externalCommunicationId: string,
  taskId: string,
): void {
  sessionStorage.setItem(
    simplifyAllTaskIdSessionKey(documentId, externalCommunicationId),
    taskId,
  );
}

export function clearSimplifyAllTaskIdFromSession(
  documentId: string,
  externalCommunicationId: string,
): void {
  sessionStorage.removeItem(
    simplifyAllTaskIdSessionKey(documentId, externalCommunicationId),
  );
}
